import React from "react";
import i18n from "i18next";
import _ from "lodash";

import HoverMenu from "material-ui-popup-state/HoverMenu";
import {
  Avatar,
  Box,
  // Divider,- uncomment when needed
  MenuItem,
  Typography,
  styled,
} from "@mui/material";
import styles from "./userMenu.module.scss";
// import { useNavigate } from "react-router-dom"; - uncomment when needed
import {
  usePopupState,
  bindHover,
  bindMenu,
} from "material-ui-popup-state/hooks";
// import { useNavbarContext } from "../../navbar/NavbarCotext"; - uncomment when needed
import { useAuth } from "../../../auth/AuthContext";
const UserBox = styled(Box)(({ isClicked }) => ({
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  gap: "10px",
  padding: isClicked ? "4px 12px 4px 12px" : "0px",
  borderRadius: "4px 4px 0px 0px",
  borderTop: isClicked ? "none" : "0",
  boxShadow: isClicked ? "0px 4px 8px rgba(0, 0, 0, 0.16)" : "none",
  background: isClicked ? "#FFFFFF" : "none",
  color: isClicked ? "#003A74" : "none",
  marginRight: "8px",
}));

const UserMenu = () => {
  const { user, logout } = useAuth();
  const userName = _.get(user, "displayName", _.get(user, "userName", ""));
  // const { setNavState } = useNavbarContext();- uncomment when needed
  // const history = useNavigate();- uncomment when needed
  const popupState = usePopupState({
    variant: "popover",
    popupId: "userMenu",
  });

  const handleClose = () => {
    popupState.close();
  };

  const handleLogOut = () => {
    logout();
    handleClose();
  };

  const getAvatarText = (userName) => {
    if (!_.isEmpty(userName)) {
      const nameArray = _.split(userName);
      let avatarText = nameArray[0][0];
      return _.toUpper(avatarText);
    }
    return "";
  };
  // const handleProfileClick = () => {- uncomment when needed
  //   setNavState({ selectedNavItem: "profile" });
  //   history("/profile");
  //   handleClose();
  // };

  return (
    <Box
      data-testid="UserMenu"
      {...bindHover(popupState)}
      className={styles.userMenuWrapper}
    >
      <Box className={styles.contentWrapper}>
        <UserBox isClicked={popupState.isOpen}>
          <Avatar
            className={
              popupState.isOpen ? styles.userAvatorClicked : styles.userAvator
            }
          >
            {getAvatarText(userName)}
          </Avatar>
          <Box
            sx={{
              display: "flex",
            }}
            className={
              popupState.isOpen
                ? styles.userAddressContainerActive
                : styles.userAddressContainer
            }
          >
            <Box className={styles.userNameandAddressContatiner}>
              <Typography variant="span" className={styles.userNameText}>
                {_.startCase(userName)}
              </Typography>
            </Box>
          </Box>
          <Box
            className={
              popupState.isOpen ? styles.chevronUpIcon : styles.chevronDownIcon
            }
          ></Box>
        </UserBox>
      </Box>
      <HoverMenu
        className={styles.dropDownMenu}
        {...bindMenu(popupState)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {/* <MenuItem - uncomment when needed
          onClick={() => handleProfileClick()}
          disableRipple
          data-testid="menuitems"
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <span className={"iconProfile"}></span>
            {i18n.t("My profile")}
          </Box>
        </MenuItem>
        <Divider variant="middle" /> */}
        <MenuItem onClick={handleLogOut} disableRipple>
          <Box className={styles.logoutWrapper}>
            <span className={"iconLogout"}></span>
            {i18n.t("Logout")}
          </Box>
        </MenuItem>
      </HoverMenu>
    </Box>
  );
};

export default UserMenu;
